import { useApiConfiguration } from "../../../api/api.configuration";
import { useAppDispatch } from "../../../contexts/hooks";
import { setLstAccionesMonitoreo, setLstUsuarios } from "../../../contexts/slices/config";
import { SysIAccionesMonitoreo } from "../../../types/types.config";
import { User } from "../../../types/types.user";

export const useFunctionsTrace = () => {
    const { getUsers, getAccionesMonitoreo } = useApiConfiguration();
    const dispatch = useAppDispatch();
    
    //Obtener la configuración necesaria para las acciones de monitoreo
    const getConfigurationTrace = () => {
        getUsers().then((res: User[]) => {
            dispatch(setLstUsuarios(res))
        })
        getAccionesMonitoreo().then((res: SysIAccionesMonitoreo[]) => {
            dispatch(setLstAccionesMonitoreo(res))
        })
    }

    return { getConfigurationTrace };
}